import { makeStyles } from '@material-ui/core/styles';

export const screenStyles = makeStyles(theme => ({
    smallMargin: {
        margin: '0px 8px',
        lineHeight: '22px'
    }
}));
